import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Order } from '@app/data-interfaces';
import { OrderService } from '@pisci/data-orders';
import { AuthService, RequestService } from '@pisci/requestManager';
import { map } from 'rxjs';

@Component({
  selector: 'app-user-account',
  templateUrl: './user-account.component.html',
  styleUrls: ['./user-account.component.scss'],
})
export class UserAccountComponent implements OnInit {
  mode = 'orders';

  showOrderId = '';
  user$;

  constructor(
    private requestService: RequestService,
    private orderService: OrderService,
    private authService: AuthService,
    private router: Router,
  ) {
    this.user$ = this.authService.select(state => state.user);
  }

  ngOnInit(): void {}

  clickLogout() {
    this.authService.logout();
    this.router.navigate(['/']);
  }
}
